import React from "react";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import { CardActions, CardContent } from "material-ui/Card";
import classnames from "classnames";
import CTable, {
  CTableHead,
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";

const styles = () => ({
  wrapper: {
    minHeight: 315
  },
  title: {
    flex: 1
  },
  cardActionsRoot: {
    padding: 12
  },
  clear: {
    clear: "both"
  },
  table: {
    fontSize: ".9rem"
  },
  tableCellLink: {
    width: 60
  },
  headCellMemo: {
    minWidth: 200
  },
  bodyCellLoginId: {
    whiteSpace: "pre"
  },
  bodyCellLink: {
    padding: 0
  }
});

const CustomerAdminCard = props => {
  const { classes, customerAdminCard } = props;
  const { customerAdmins } = customerAdminCard;

  return (
    <div className={classes.wrapper}>
      <CardActions classes={{ root: classes.cardActionsRoot }}>
        <h4 className={classes.title}>顧客担当者</h4>

        <Button raised onClick={() => props.openModal()}>
          追加
        </Button>
      </CardActions>

      <CardContent className={classes.cardContent}>
        <CTable className={classes.table}>
          <CTableHead>
            <CTableRow>
              <CHeadCell className={classes.headCellLoginId}>
                担当者ID
              </CHeadCell>
              <CHeadCell>担当者名</CHeadCell>
              <CHeadCell>メールアドレス</CHeadCell>
              <CHeadCell
                className={classnames(classes.headCell, classes.headCellMemo)}
              >
                メモ
              </CHeadCell>
              <CHeadCell className={classes.tableCellLink}>{}</CHeadCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {customerAdmins.map(customerAdmin => (
              <CTableRow key={customerAdmin.id}>
                <CBodyCell className={classes.bodyCellLoginId}>
                  {customerAdmin.adminKey}
                </CBodyCell>
                <CBodyCell>{customerAdmin.adminName}</CBodyCell>
                <CBodyCell>{customerAdmin.mail}</CBodyCell>
                <CBodyCell>{customerAdmin.memo}</CBodyCell>
                <CBodyCell className={classes.bodyCellLink} center>
                  <Button onClick={() => props.openModal(customerAdmin)}>
                    編集
                  </Button>
                </CBodyCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
      </CardContent>
      <div className={classes.clear} />
    </div>
  );
};

export default withStyles(styles)(CustomerAdminCard);



// WEBPACK FOOTER //
// ./src/components/CustomerDetail/CustomerAdminCard.jsx